<template>
    <v-container class="admin-email-template">
        <v-row class="flex-grow-0">
            <v-col>
                <label class="text-h5">{{ $t('admin_hkiarace.email_template') }}</label>
            </v-col>
        </v-row>
        <v-row class="flex-grow-1">
            <v-col class="pa-0">
                <EmailTemplateList full-height
                                   :refresh-trigger.sync="refreshTrigger"
                                   data-url="aafb/admin/email_template/"
                                   @edit="onEmailTemplateEdit"></EmailTemplateList>
            </v-col>
        </v-row>

        <EditEmailTemplateModal :shown="editEmailTemplateModalShown"
                                :email-template-id="editingEmailTemplateId"
                                data-url="aafb/admin/email_template/"
                                @cancel="onEditEmailTemplateModalFinish"
                                @finish="onEditEmailTemplateModalFinish"></EditEmailTemplateModal>
    </v-container>
</template>

<script>
import {ref} from "@vue/composition-api";
import EmailTemplateList from "@/components/emailTemplate/EmailTemplateList";
import EditEmailTemplateModal from "@/components/emailTemplate/EditEmailTemplateModal";

export default {
    name: 'EmailTemplate',
    components: {EditEmailTemplateModal, EmailTemplateList},
    setup(props, {root}) {
        const refreshTrigger = ref(false);
        const refresh = function () {
            refreshTrigger.value = !refreshTrigger.value;
        };

        const addEmailTemplateModalShown = ref(false);
        const onAddEmailTemplateModalFinish = function (item) {
            addEmailTemplateModalShown.value = false;
            refresh();
            onEmailTemplateEdit(item);
        }

        const editingEmailTemplateId = ref(null);
        const editEmailTemplateModalShown = ref(false);
        const onEmailTemplateEdit = function (item) {
            editingEmailTemplateId.value = item.id;
            editEmailTemplateModalShown.value = true;
        };
        const onEditEmailTemplateModalFinish = function () {
            editEmailTemplateModalShown.value = false;
            refresh();
        }

        return {
            refreshTrigger,
            refresh,

            addEmailTemplateModalShown,
            onAddEmailTemplateModalFinish,

            editingEmailTemplateId,
            editEmailTemplateModalShown,
            onEmailTemplateEdit,
            onEditEmailTemplateModalFinish,
        }
    }
}
</script>

<style lang="less">
.admin-email-template {
    height: 100%;
    display: flex;
    flex-direction: column;
}
</style>
